module.exports = __webpack_public_path__ + "img/Icon_info_Cancle.03f0e1c3.png";